import React, { memo, useMemo } from 'react';
import { useFormContext, useController } from './node_modules/.pnpm/react-hook-form@7.41.1_react@18.2.0/node_modules/react-hook-form/dist/index.esm.js';
import { FieldLabel } from './FieldLabel.js';
import { Paragraph } from './Paragraph.js';
import { useFieldAttrs } from './hooks/useFieldAttrs.js';
import { useValidations } from './hooks/useValidations.js';

const FieldHelp = memo(({ className = '', position = 'bottom', theme = 'dark', helpText }) => helpText ? (React.createElement(Paragraph, { className: [
        position === 'bottom' ? '' : '-mt-2.5',
        'col-span-full',
        className,
    ].join(' '), size: position === 'bottom' ? 'xsmall' : 'medium', variant: theme === 'light' ? 'dark' : 'medium' }, helpText)) : null);
const FieldMemoized = memo(React.forwardRef(({ component, ...props }, ref) => React.cloneElement(component, { ...props, ref })));
const FieldWrap = ({ classNameWrap = '', classNameLabel = '', children, handleErrors = false, handleValue = false, helpText, label, labelSize = 'default', labelVisible = true, name, matchAgainst, theme, validations = [], ...rest }) => {
    const { control, setError, setValue, watch } = useFormContext();
    const validationObject = useValidations({
        validations,
        matchAgainst: matchAgainst ? watch(matchAgainst) : null,
        ...rest,
    });
    const { field, fieldState: { error, invalid }, } = useController({
        name,
        control,
        rules: validationObject,
    });
    const fieldAttrs = useFieldAttrs({ invalid, name });
    const errorMessages = useMemo(() => {
        if (!error) {
            return null;
        }
        return error.types ? Object.values(error.types) : [error.message];
    }, [error]);
    return (React.createElement("div", { className: ['grid gap-y-3', classNameWrap].join(' ') },
        label && (React.createElement(React.Fragment, null,
            React.createElement(FieldLabel, { ...{
                    className: [
                        labelSize === 'small' || labelSize === 'xsmall' ? '-mb-2' : '',
                        classNameLabel,
                    ].join(' '),
                    id: fieldAttrs.id,
                    label,
                    labelVisible,
                    size: labelSize,
                } }),
            labelVisible && (React.createElement(FieldHelp, { ...{
                    helpText,
                    position: 'top',
                    theme: theme,
                } })))),
        React.createElement(FieldMemoized, { ...{
                component: children,
                invalid,
                ...fieldAttrs,
                ...field,
                ...(handleErrors ? { setError } : {}),
                ...(handleValue ? { setValue } : {}),
                ...rest,
            } }),
        !labelVisible && (React.createElement(FieldHelp, { ...{
                helpText,
                theme: theme,
            }, className: "-mt-1" })),
        errorMessages && (React.createElement("div", { className: "flex flex-wrap col-span-full", "aria-live": "polite" }, errorMessages.map((error, errorKey) => (React.createElement("span", { key: errorKey, id: fieldAttrs['aria-describedBy'], className: "bg-red-300 rounded-xl py-0.5 px-3 text-sm text-red-900 leading-tight mr-1 mb-1", "aria-hidden": "true" }, error)))))));
};

export { FieldMemoized, FieldWrap };
//# sourceMappingURL=FieldWrap.js.map
